module.exports = __webpack_public_path__ + "static/media/10_Foundation_ Rita Ku.a91b9599.jpeg";